import React, { FC } from 'react'

import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
  @media screen and (max-width: 767px) {
    align-items: flex-start;
  }
`

const StyledInfoIcon = styled(InfoIcon)`
  color: ${({ theme }) => theme.color.darkGrey};
  @media screen and (max-width: 767px) {
    margin-top: 4px;
  }
`

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export const MaxSelectedGenresMessage: FC = () => (
  <Container>
    <StyledInfoIcon />
    <Text>Limit reached! You can select up to 7 genres for your track.</Text>
  </Container>
)
